export const getStore = (key: string, default_value: any) => {
	const storedValue = localStorage.getItem(key);
	if (!storedValue) return default_value;
	if (storedValue === "undefined") return undefined;
	return JSON.parse(storedValue);
};

export const setStore = (key: string, value: any) => {
	if (value === undefined) {
		localStorage.removeItem(key);
	} else {
		localStorage.setItem(key, JSON.stringify(value));
	}
};
